import './NewsCarouselItemGlobal.css';
import ScrollAnimation from 'react-animate-on-scroll';
import { get, injectImageResolution } from '../../../../utils';
import LazyPicture from '../../../atoms/LazyPicture';
import RouterLink from '../../../atoms/RouterLink';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import React, { useRef } from 'react';
import { useSitecoreContext } from '../../../../utils/SitecoreContextReactContext';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../../../utils/tealium';
const NewsCarouselItemGlobal = _ref => {
  let {
    title,
    introText,
    image,
    variant,
    url,
    date,
    category,
    showCarousel,
    eventsAnalytics,
    params
  } = _ref;
  const itemWrapperRef = useRef(null);
  const sitecoreContext = useSitecoreContext();
  const showImage = variant === 'WithImage' && image;
  const showForDefaultItem = variant === 'WithImage' || variant === 'Default';
  const currentLang = get(sitecoreContext, 'language');
  const setDateFormat = (date, lang) => {
    return new Date(date).toLocaleDateString(lang, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: showForDefaultItem && !showCarousel ? itemWrapperWithoutCarousel : itemWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: `${showForDefaultItem ? styleForDefaultItem : variant === 'VerticalList' ? styleForList : styleForGrid} ${commonStyles}`,
    ref: itemWrapperRef
  }, showImage ? /*#__PURE__*/React.createElement("div", {
    className: "image-container"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    href: url,
    linktype: 'internal',
    linksTarget: '',
    title: title,
    onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bannerClickAnalytics'], params), [title])
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 992px)",
    srcSet: `${injectImageResolution(image, 460, 259)}`
  }), /*#__PURE__*/React.createElement("img", {
    src: `${injectImageResolution(image, 460, 346)}`,
    alt: title
  })))) : variant === 'Default' ? null : /*#__PURE__*/React.createElement("div", {
    className: `${variant === 'Grid' ? 'date-grid-container' : 'date-list-container'}`
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, date && /*#__PURE__*/React.createElement("div", {
    className: "date-grid-list-wrapper"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "date",
    field: {
      value: setDateFormat(date, currentLang)
    }
  }))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, category && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "date-title",
    field: {
      value: category[0].toUpperCase()
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "text-container"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    className: "date-wrapper",
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, date && showForDefaultItem && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "date",
    field: {
      value: setDateFormat(date, currentLang)
    }
  }))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    className: "title-wrapper",
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, title && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RouterLink, {
    onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), [title]),
    href: url,
    linktype: 'internal',
    linksTarget: '',
    title: title
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: "title",
    field: {
      value: title
    }
  })))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    className: "description-wrapper",
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, introText && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    className: "description",
    tag: "p",
    field: {
      value: introText
    }
  }))))));
};
const itemWrapperWithoutCarousel = "ifh9e0g";
const itemWrapper = "i73vayk";
const styleForGrid = "s16x8ebg";
const styleForList = "sf4616m";
const styleForDefaultItem = "saqegaf";
const commonStyles = "c1090l1q";
export default NewsCarouselItemGlobal;